import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { GatekeeperService } from '@shared/services';
import { catchError, Observable, of, switchMap } from 'rxjs';

// Need to add data.gatekeeperToggle to the route with the desired gatekeeperToggle string
@Injectable()
export class GatekeeperGuard {
  constructor(
    private gateKeeper: GatekeeperService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const {
      gatekeeperToggle,
      redirectLocationWhenToggleOff,
      redirectLocationWhenToggleOn,
      inverseGuard = false,
    } = route.data;
    const redirectLocation = inverseGuard
      ? redirectLocationWhenToggleOn
      : redirectLocationWhenToggleOff;
    return this.gateKeeper.getGatekeeper(gatekeeperToggle).pipe(
      switchMap((value) => {
        const isAllowed = inverseGuard ? !value : value;
        if (isAllowed) return of(true);
        if (redirectLocation) {
          this.router.navigate([redirectLocation]);
        } else {
          window.history.back();
        }
        return of(false);
      }),
      catchError(() => of(false)),
    );
  }
}
